<template>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;margin-bottom: 80px;">
        <span class="c-mb-10">连接理论与应用的桥梁，赋能教学与研究</span>
        <h1>FRANKA TOOLBOX FOR MATLAB</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
            Franka Toolbox for MATLAB 提供FR3机器人的全系列控制选项与信号接口，为学生和研究者打造高效直观的算法验证方案——无论是实验室攻关还是课堂实践皆可适用。该工具箱包含丰富的MATLAB®脚本库、Simulink®功能模块组以及高级应用示例集，全面覆盖机器人控制的多种应用场景。
        </span>
        <!-- <div class="buttonSite" > -->
          
            <!-- <router-link to="/contact" class="buttonSite">GitHub平台下载</router-link> -->
             <div class="buttonSite">
                <a href="https://github.com/frankarobotics/franka_toolbox_for_matlab" target="_self"> GitHub平台下载</a>
              </div> 
            <div class="linkTag"> 
                  <router-link to="/develop" >开发资源导航</router-link>
              </div> 
        <!-- </div> -->
      </div>
      
  
      <div class="display-width"> 
        <img src="@/assets/images/resources/Annika Franka Matlab.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>  
    <div id="resources-development"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">关键特点</span>
      <hr class="divider">
    </div>
    
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;margin-bottom: 80px;">
        <h3 style="font-size: 22px;margin-bottom: 8px;">开源与免费许可</h3>
        <span class="c-mb-10 c-text-left" >工具箱完全透明，可供访问、修改和贡献。Franka Toolbox for MATLAB 现已开源——免费许可，向所有人开放。</span> 
      </div>  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;margin-bottom: 80px;">
        <h3 style="font-size: 22px;margin-bottom: 8px;">GitHub 轻松获取</h3>
        <span class="c-mb-10 c-text-left" >在 GitHub 上下载最新版本或直接浏览源代码。与社区协作、报告问题并贡献新功能。</span> 
      </div>  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;margin-bottom: 80px;">
        <h3 style="font-size: 22px;margin-bottom: 8px;">快捷无缝集成</h3>
        <span class="c-mb-10 c-text-left">通过 Franka Toolbox for MATLAB 提供的直连集成，可将 Franka 机器人无缝接入广受欢迎的编程平台 MATLAB 和 Simulink。</span> 
      </div>  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;margin-bottom: 80px;">
        <h3 style="font-size: 22px;margin-bottom: 8px;">机器人直连控制</h3>
        <span class="c-mb-10 c-text-left">通过 1 kHz 实时闭环建立与机器人的直接连接：开发涵盖力矩控制等多种模式的控制算法，利用可视化数据和简化调试流程，加速原型开发。</span> 
      </div>  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;margin-bottom: 80px;">
        <h3 style="font-size: 22px;margin-bottom: 8px;">实时数据处理</h3>
        <span class="c-mb-10 c-text-left">借助 MATLAB 绘图功能及 Simulink 特性，轻松显示、采集和记录机器人的实时数据（如力、位置、关节角度等）。</span> 
      </div>  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;margin-bottom: 80px;">
        <h3 style="font-size: 22px;margin-bottom: 8px;">丰富示例资源</h3>
        <span class="c-mb-10 c-text-left">基于现有示例加速开发，专注实现特定应用。通过熟悉的软件环境，降低机器人技术入门门槛。</span> 
      </div>  
    </div>

    <div class="c-text-between  c-flex-wrap" style="  background: rgb(239, 241, 243);padding: 80px;">  
      <div class="display-width c-text-both" style="aspect-ratio: 780/562;"> 
        <div  style="width: 100%;" class="c-text-both" v-show="iframe1==2"> 
        <img  src="@/assets/images/resources/hqdefault.jpg" style="width: 100%;aspect-ratio: 780/562;" />
        <div class="playButton " @click="iframe1=1">  
        </div>
        </div>
        <iframe
            src="https://player.bilibili.com/player.html?bvid=BV1vs9pYYEP3" v-if="iframe1==1"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="no"
            allowfullscreen="true"
        ></iframe>
        </div>
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1>来自维也纳科技大学的成功故事</h1>
        <span class="c-mt-10 c-mb-10 c-text-left ">
            在维也纳科技大学（TU Wien）的自动化与控制研究所（ACIN），Christian Ott 教授的团队在操作和运动领域进行研究。他们利用与 MATLAB Simulink 接口连接的 Franka 机器人，能够无缝地将理论和仿真环境中开发的算法直接过渡到现实世界的机器人应用中。在一个以硬件在环仿真为核心的项目中，该工具箱实现了与机器人之间的实时通信。通过使用 Simulink 中的集成模块，如变换矩阵，研究人员能够实时监控系统的各个方面。此外，他们还可以实时向机器人发送扭矩指令。这一简化的过程优化了他们的工作流程，使他们能够更专注于控制系统的开发。
        </span> 
      </div> 
    </div> 
    <div id="resources-community"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">不断发展的生态系统</span>
      <hr class="divider">
    </div>
    
    <div class="c-text-between px-container c-flex-wrap">  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;"> 
            <h1>一个不断壮大的生态系统</h1>
            <span class="c-mt-10 c-text-left">该工具箱只是 Franka Robotics 生态系统增强的一部分，它与 Franka ROS 2 等产品互为补充，并能轻松集成。这些协同作用使用户能够充分利用 Franka 机器人的强大数据采集和实时控制能力。</span>
            <span class="c-mt-10 c-text-left text-indent">
                "在 Franka Robotics，我们的使命是开发能够赋能创新者和颠覆者的技术，让他们能够实现机器人技术和人工智能的承诺，共同建设更美好的未来。
            </span> 
            <span class="c-text-left">
                这也是为什么我们致力于为研究人员提供最好的机器人平台。在这方面，Franka Toolbox for MATLAB 代表了将前沿机器人硬件与 MATLAB 和 Simulink 的强大功能与多样性相结合的成果。"
            </span>
            <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
            </div>
            <strong>Sven Parusel，</strong>
            <strong>学术与研究高级副总裁</strong>
            <strong>Franka Robotics</strong>
            <!-- <div class="buttonSite c-mt-40" > -->
                <router-link to="/contact" class="buttonSite c-mt-40">联系我们</router-link>
            <!-- </div> -->
      </div>   
      <div class="display-width">
        <img src="@/assets/images/resources/Portrait_Sven_DualArm 4-2.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>

  </template>
  
  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {  
        iframe1:2,
        
      }
    }, 
  }
  </script>
  
  <style scoped>
  
  .display-width{
    width: calc(50% - 40px);
  }
  
@media (max-width: 1029px) {
  }
  
  /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .display-width{
      width: 100%
    }
  }
  
  /* 屏幕宽度小于 600px 时，一行展示 1 个 */
  @media (max-width: 599px) {
  }
  
  </style>
  <style scoped> 
  /* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
  </style>
  